import { IAssetCategoryResponse } from '@kcftech/prometheus-client';
import { HighlightedText } from 'components/text/HighlightedText';

export type HighlightedAssetCategoryNameProps = Readonly<{
    category: IAssetCategoryResponse;
    filterText: string;
}>;

export function HighlightedAssetCategoryName({
    category,
    filterText,
}: HighlightedAssetCategoryNameProps) {
    return <HighlightedText text={category.ShortName ?? ''} terms={[filterText]} />;
}
